export const calculateMortgage = (price, downPayment, interestRate, loanTerm) => {
  if (!interestRate || interestRate === "" || isNaN(parseFloat(interestRate))) return "";
  const principal = price * (1 - downPayment / 100);
  const monthlyRate = parseFloat(interestRate) / 100 / 12;
  const numberOfPayments = loanTerm * 12;
  const mortgage =
    (principal * monthlyRate * Math.pow(1 + monthlyRate, numberOfPayments)) /
    (Math.pow(1 + monthlyRate, numberOfPayments) - 1);
  return mortgage.toFixed(2);
};